import React, { useEffect } from 'react';

export default function ProductionStandards() {
  useEffect(() => {
    document.title = 'Production Standards | Bay Area Podcast Studio';
    let meta = document.querySelector('meta[name="robots"][data-legal]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('data-legal', 'true');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, follow');
    return () => {
      document.title = 'Bay Area Podcast Studio';
      if (meta && meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  return (
    <main className="pt-[72px] min-h-screen bg-[#FFFFFF]">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-24 text-[#000000]">
        <h1 className="text-3xl md:text-5xl font-black mb-8 tracking-tight uppercase">Production Standards</h1>
        
        <div className="space-y-6 text-sm md:text-base leading-relaxed font-medium">
          <div className="font-bold uppercase">
            <p>Claxxiq LLC // Bay Area Podcast Studio</p>
            <p>Last Revised: May 2026</p>
          </div>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">I. Schedule & Punctuality</h2>
          <p>
            Your session starts exactly at your booked time. All hosts and guests are required to arrive 15 minutes prior to the start time for mic checks, lighting adjustments, and framing. Late arrivals will reduce your overall recording time, but the full session fee remains non-refundable. We do not push back subsequent client bookings to accommodate lateness.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">II. Content Ownership & Promotional Rights</h2>
          <p>
            You retain 100% ownership of all content created during your session. Your booking fee is a complete buyout; zero royalties or recurring fees are owed to Claxxiq LLC regardless of how successful your content becomes.
          </p>
          <p>
            By recording in our facility, you permit us to capture behind-the-scenes photos, video clips, or brief highlights strictly for studio promotional use. We will never publish your full show, nor will we post highlight clips prior to your primary content release. If your project is under a formal NDA, notify our operator prior to recording.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">III. FILE STORAGE & DIGITAL DELIVERY</h2>
          <p>
            The standard method for media delivery is an immediate, on-site transfer to your personal high-speed SSD at the conclusion of your session. If you opt for the paid Cloud File Delivery add-on, or if you purchase post-production editing services, you will receive a secure digital download link. Any media provided via digital link is hosted on our active servers for exactly 30 days from the date of issue. After 30 days, all raw and edited files are permanently purged from our systems to maintain server capacity. Downloading, storing, and backing up your media within this 30-day window is entirely your responsibility.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">IV. Music & Third-Party Media</h2>
          <p>
            We do not provide or broadcast copyrighted music. You are responsible for ensuring that any music, audio, or video brought into your session is fully licensed or legally owned by you. This keeps your show protected from copyright strikes or legal disputes on distribution platforms.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">V. Facility Care & Gear Liability</h2>
          <p>
            To maintain our standard of quality, only designated studio operators are permitted to handle cameras, lighting, microphones, and audio equipment. The client assumes full financial responsibility for any physical damage to studio gear or property caused by the client or their guests.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">VI. Technical Failures & Conduct</h2>
          <p>
            <span className="font-bold">Technical Errors:</span> In the rare event of a hardware or software failure resulting in lost data, studio liability is strictly limited to a full refund of the session fee or a complimentary reschedule. We are not liable for external costs such as guest travel or lost time.
          </p>
          <p>
            <span className="font-bold">Professional Environment:</span> We reserve the right to terminate any session immediately, without refund, if guest conduct becomes abusive, illegal, or creates a safety risk for our staff or facility.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">VII. Outages & Uncontrollable Events</h2>
          <p>
            If a session is interrupted or prevented by events beyond our control (such as city-wide power outages, service failures, or natural emergencies), our priority is to reschedule your booking at the earliest available time.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">VIII. Cancellations & Rescheduling</h2>
          <p>
            <span className="font-bold">24+ Hours Notice:</span> Full refund or immediate credit toward a future booking.
          </p>
          <p>
            <span className="font-bold">Under 24 Hours Notice:</span> Booking fees become non-refundable, but 100% of your credit will roll over toward a rescheduled date of your choice.
          </p>
        </div>
      </div>
    </main>
  );
}